/* eslint-disable complexity */
import React, { useMemo } from 'react';
import cn from 'classnames';
import { arrayOf, bool, string } from 'prop-types';

import { deserializer } from '~services/baseSerializers';
import { normalizeBusinessHours, mergeSchedules } from '~utils/time';
import { businessHoursPropTypes } from '~constants/propTypes';

import { DELIVERY_TYPES_MAPPER } from './constants';
import HoursContainer from './components/HoursContainer';

const BusinessHours = ({
  businessHours,
  className,
  noDayName,
  noTitle,
  containerClassName,
  dispatchType
}) => {
  const normalizedHours = useMemo(() => {
    const serializedHours =
      businessHours && deserializer.serialize(normalizeBusinessHours(businessHours, null, true));
    const isBothOnly = serializedHours && Object.keys(serializedHours)[0] === DELIVERY_TYPES_MAPPER.both;
    const deliveryType = isBothOnly ? DELIVERY_TYPES_MAPPER.both : DELIVERY_TYPES_MAPPER[dispatchType];
    return serializedHours[deliveryType] && mergeSchedules(serializedHours[deliveryType]);
  }, [businessHours, dispatchType]);
  return (
    <div className={cn('column', containerClassName)}>
      {normalizedHours && (
        <HoursContainer
          className={className}
          noTitle={noTitle}
          noDayName={noDayName}
          hoursArray={normalizedHours}
        />
      )}
    </div>
  );
};

BusinessHours.propTypes = {
  businessHours: arrayOf(businessHoursPropTypes),
  className: string,
  containerClassName: string,
  dispatchType: string,
  noDayName: bool,
  noTitle: bool
};

export default BusinessHours;
